import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ActiveLink from "@/components/ActiveLink";
import ScrollMenu from "@/components/ScrollMenu";
import styles from "@/styles/TabMenu.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
function Menu(_ref) {
  let {
    element,
    text,
    link
  } = _ref;
  return /*#__PURE__*/_jsx(ActiveLink, _objectSpread(_objectSpread({}, link), {}, {
    children: /*#__PURE__*/_jsx("a", {
      className: styles.menu,
      children: element || text
    })
  }));
}
export default function TabMenu(_ref2) {
  let {
    menus
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsx(ScrollMenu, {
      children: menus.map((menu, i) => /*#__PURE__*/_jsx(Menu, _objectSpread({}, menu), `menu=${i}`))
    })
  });
}